import { requiredFilterPath } from "./constants";

function isValidSpecificEducation(specific: any): boolean {
    if (!specific) return false;
  
    const hasValidDegrees =
      Array.isArray(specific?.degrees) &&
      specific.degrees.some(
        (deg: any) =>
          typeof deg?.degree === "string" &&
          deg.degree.trim() !== "" &&
          Array.isArray(deg.specializations) &&
          deg.specializations.length > 0
      );
  
    const hasInstitutions =
      Array.isArray(specific?.institutions) && specific.institutions.length > 0;
  
    return hasValidDegrees || hasInstitutions;
}  

function sanitizeSearchPayload(
    filters: any = {},
    api_profile_flag: any
  ): any {
    const updatedFilters: any = { ...filters };
  
    // ─── REMOVE FILTERS IF API PROFILE FLAG IS NOT 1 ─────────────
    // if (api_profile_flag != 1) {
    //   if (
    //     updatedFilters.additional &&
    //     typeof updatedFilters.additional === "object"
    //   ) {
    //     updatedFilters.additional = { ...updatedFilters.additional };
    
    //     const removeFromAdditional = [
    //       "age_from",
    //       "age_to",
    //       "job_type",
    //       "disability_type",
    //       "show_only_verified_email",
    //       "show_only_verified_mobile",
    //       "show_resumes_not_viewed",
    //     ];
    
    //     removeFromAdditional.forEach((key) => {
    //       delete updatedFilters.additional[key];
    //     });
    
    //     if (Object.keys(updatedFilters.additional).length === 0) {
    //       delete updatedFilters.additional;
    //     }
    //   }
    
    //   // ─── NATIONALITY STRIP IF NOT API PROFILE ───
    //   if (
    //     updatedFilters.nationality &&
    //     typeof updatedFilters.nationality === "object"
    //   ) {
    //     const cleanedNationality = { ...updatedFilters.nationality };
    //     delete cleanedNationality.us_work_auth;
    //     delete cleanedNationality.visa_status;
    
    //     if (Object.keys(cleanedNationality).length === 0) {
    //       delete updatedFilters.nationality;
    //     } else {
    //       updatedFilters.nationality = cleanedNationality;
    //     }
    //   }
    // }
    
  
  //   console.log({ updatedFilters });
    // ─── COMPANY ───────────────────────────────
  // Handle company cleanup
  const c = updatedFilters.company;
  if (c && typeof c === "object") {
    // const noCTC = !c?.min_ctc && !c?.max_ctc;
    const noNoticePeriod = !("notice_period" in c);
  
    // Check both designations AND designation_categories - scope should be kept if either has values
    const noDesignations = (!Array.isArray(c?.designations) || c.designations.length === 0) &&
                           (!Array.isArray(c?.designation_categories) || c.designation_categories.length === 0);
    const noAnyCompanies = !Array.isArray(c?.any) || c.any.length === 0;
    const noExcludeCompanies = !Array.isArray(c?.exclude) || c.exclude.length === 0;
    const noImmediateJoiner = !c?.immediate_joiner;
  
    const cleanedCompany: any = { ...c };
    // cleanedCompany.serving_notice_period = 1;
  
    // if (noCTC) delete cleanedCompany.include_profiles_with_no_ctc;
    // if (noNoticePeriod) {
    //   delete cleanedCompany.include_profiles_with_no_notice_period;
    //   delete cleanedCompany.serving_notice_period;
    // }
    if (noDesignations) delete cleanedCompany.designations_scope;
    if (noAnyCompanies) delete cleanedCompany.any_scope;
    if (noExcludeCompanies) delete cleanedCompany.exclude_scope;
    if (noImmediateJoiner) delete cleanedCompany.immediate_joiner;
    if (!cleanedCompany?.currency) cleanedCompany.currency = "INR";
  
    updatedFilters.company =
      Object.keys(cleanedCompany).length > 0 ? cleanedCompany : undefined;
  }
  
  // Handle industry cleanup
  const ind = updatedFilters.industry;
  if (ind && typeof ind === "object") {
    const cleanedIndustry: any = { ...ind };
    const noIndustries = !Array.isArray(ind?.industries) || ind?.industries?.length === 0;
    if (noIndustries) {
      delete cleanedIndustry.any_scope;
      delete cleanedIndustry.include_profiles_with_no_industries;
    }
  
    updatedFilters.industry =
      Object.keys(cleanedIndustry).length > 0 ? cleanedIndustry : undefined;
  }
  
  
   //  _____AGE filter cleanup_____
  
    const age_to = updatedFilters.additional.age_to;
    const age_from = updatedFilters.additional.age_from;
    if (age_from && Number(age_from) > 60) {
      updatedFilters.additional = {
        ...updatedFilters.additional,
        age_from: 60,
      };
    }
    if (age_to && Number(age_to) > 60) {
      // updatedFilters.additional.age_to = 61;
      updatedFilters.additional = {
        ...updatedFilters.additional,
        age_to: 61,
      };
    }
  
    // ─── NATIONALITY ───────────────────────────
    const n = updatedFilters?.nationality;
    if (n && typeof n === "object") {
      const noCitizenShip =
        !Array.isArray(n?.nationalities) || n.nationalities.length === 0;
      const cleanedNationality: any = { ...n };
      if (noCitizenShip) {
        delete cleanedNationality.include_permanent_residents;
        delete cleanedNationality.include_work_auth;
      }
      updatedFilters.nationality =
        Object.keys(cleanedNationality).length > 0
          ? cleanedNationality
          : undefined;
    }
  
    // // ─── INDUSTRY ──────────────────────────────
    // const i = updatedFilters.industry;
    // if (i && typeof i === "object") {
    //   const cleanedIndustry = { ...i };
    //   if (!Array.isArray(i?.industries) || i.industries.length === 0) {
    //     delete cleanedIndustry.any_scope;
    //   }
    //   updatedFilters.industry =
    //     Object.keys(cleanedIndustry).length > 0 ? cleanedIndustry : undefined;
    // }
  
    // ─── LOCATION ──────────────────────────────
    const loc = updatedFilters.location;
    if (loc && typeof loc === "object") {
      const hasCurrent =
        Array.isArray(loc.current_locations) && loc.current_locations.length > 0;
      const hasPreferred =
        Array.isArray(loc.preferred_locations) &&
        loc.preferred_locations.length > 0;
      if (!hasCurrent || (hasPreferred && !hasCurrent)) {
        delete updatedFilters.location;
      }
    }
  
    // ─── EDUCATION ─────────────────────────────
    const edu = updatedFilters.education;
    if (edu && typeof edu === "object") {
      if ("highest" in edu) {
        // Leave highest as-is
      } else {
        const validEdu: any = {};
        const alwaysValidKeys = [
          "no_ug",
          "no_pg",
          "no_ppg",
          "any_ug",
          "any_pg",
          "any_ppg",
        ];
        for (const key of alwaysValidKeys) {
          if (edu?.[key]) validEdu[key] = edu[key];
        }
  
        for (const level of ["ug", "pg", "ppg"]) {
          const key = `specific_${level}`;
          const value = edu?.[key];
          if (isValidSpecificEducation(value)) {
            const cleanedLevel = { ...value };
            if (
              !Array.isArray(cleanedLevel.institutes) ||
              cleanedLevel.institutes.length === 0
            ) {
              delete cleanedLevel.institutes;
            }
            validEdu[key] = cleanedLevel;
          }
        }
  
        // Force condition to always be "AND" regardless of what comes from saved search or store
        if (Object.keys(validEdu).length > 0 && edu?.condition) {
          validEdu.condition = "AND";
        }
  
        updatedFilters.education =
          Object.keys(validEdu).length > 0 ? validEdu : undefined;
      }
    }
  
    const insightKeys = [
      "experience_insight",
      "education_insight",
      "personal_insight",
      "work_experience_insights",
    ];
    
    insightKeys.forEach((key) => {
      const insight = updatedFilters[key];
      if (insight && typeof insight === "object") {
        const cleanedInsight: any = {};
        for (const subKey in insight) {
          if (insight[subKey] === true) {
            cleanedInsight[subKey] = true;
          }
        }
    
        if (Object.keys(cleanedInsight).length > 0) {
          updatedFilters[key] = cleanedInsight;
        } else {
          delete updatedFilters[key];
        }
      }
    });
    
    // ─── FINAL CLEANUP ─────────────────────────
    for (const key in updatedFilters) {
      if (updatedFilters[key] === undefined) {
        delete updatedFilters[key];
      }
    }
  
    return updatedFilters;
}

export function hasValidFilterAdded(newObj: Record<string, any>) {
    /**
     * 1. Gender any is being passed as a value
     * 2.
     * */
    const obj = {
      ...sanitizeSearchPayload(newObj.filters, newObj.api_profile_flag),
      refine_search: newObj.refine_search,
      queries: {
        all: newObj.queries?.all ?? "",
        combined: newObj.queries?.combined ?? [],
        any: newObj.queries?.any ?? "",
        exclude: newObj.queries?.exclude ?? "",
        boolean: newObj.queries?.boolean ?? "",
      },
    };
    const results: boolean[] = [];
    requiredFilterPath.forEach((path) => {
      const nestedPath = path.split(".");
      let current = obj;
      for (let index = 0; index < nestedPath.length; index++) {
        const key = nestedPath[index];
  
        if (current == null) break; // safety check
        current = current[key];
      }
      results.push(!!(current?.length ?? current));
    });
    return results.includes(true);
}
